import type { ApexOptions } from 'apexcharts';

export type ResolvedTheme = 'light' | 'dark';

export function chartThemeOptions(theme: ResolvedTheme): ApexOptions {
  const dark = theme === 'dark';
  return {
    theme: { mode: theme },
    chart: {
      foreColor: dark ? '#d4d4d8' : '#27272a',
      background: 'transparent',
      toolbar: { show: false },
      animations: { enabled: true, speed: 250 },
      fontFamily: 'Inter, ui-sans-serif, system-ui',
    },
    grid: {
      borderColor: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
    },
    tooltip: { theme },
    legend: {
      labels: { colors: dark ? '#d4d4d8' : '#27272a' },
    },
  };
}
